import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
} from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';

import { routes } from './app.routes';
import { appEffectsModules, rootReducers, metaReducers } from './reducers';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AuthInterceptorService } from './components/services/auth-interceptor.service';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { provideServiceWorker } from '@angular/service-worker';
// ✅ ADD THESE:
import { Overlay, OverlayModule } from '@angular/cdk/overlay';
import { MAT_TOOLTIP_SCROLL_STRATEGY } from '@angular/material/tooltip';

export function tooltipScrollStrategyFactory(overlay: Overlay) {
  return () => overlay.scrollStrategies.reposition();
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),

    provideAnimationsAsync(),
    provideAnimationsAsync(),
    // ✅ IMPORTANT: make Overlay injectable at root
    importProvidersFrom(OverlayModule),

    // ✅ GLOBAL FIX for tooltip scroll issue
    {
      provide: MAT_TOOLTIP_SCROLL_STRATEGY,
      useFactory: tooltipScrollStrategyFactory,
      deps: [Overlay],
    },

    provideStore(rootReducers, { metaReducers }),
    provideEffects(appEffectsModules),
    provideHttpClient(
      // DI-based interceptors must be explicitly enabled.
      withInterceptorsFromDi()
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    // importProvidersFrom(
    //   NgxDaterangepickerMd.forRoot({
    //     separator: ' - ',
    //     applyLabel: 'Apply',
    //     cancelLabel: 'Cancel',
    //   })
    // ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideAnimationsAsync(),
  ],
};
